/**
 * Actors - Single (detail view)
 */

'use strict';

var ui = require('../misc/layout');
var conditionalFields = require('../../admin/misc/conditionalFields');

// Constructor
var FrontActorsSingle = function () {

    if (!$('body').hasClass('single-cm-actors')) {
        return;
    }

    this.hoverMainPicture();

    $(document).ready((function () {
        this.computeUiElementsPosition();
        this.initCollapsible();
        this.initGallery();
        this.initDatepicker();
        this.initSideNav();
        this.setConditionalFields();
        this.newsSelectFields();
        this.updateNews();
        this.deleteNews();
        this.getMoreNews();
        this.submitEventNewsForm();
        this.submitNewsForm();
        this.experienceSelectFields();
        this.updateExperience();
        this.deleteExperience();
        this.submitExperienceForm();
        this.submitForm();
        this.submitContactForm();
        this.submitAddressesForm();
        this.updateAddress();
        this.deleteAddress();
        this.submitCharacteristicsForm();
        this.updateCharacteristics();
        this.submitAgencyForm();
        this.updateAgency();
        this.updateLanguage();
        this.deleteLanguage();
        this.submitLanguageForm();
        this.addOtherLanguage();
        this.updateSkill();
        this.deleteSkill();
        this.submitSkillForm();
        this.submitOtherSkillsForm();
        this.updateOtherSkills();
        this.updateSchool();
        this.deleteSchool();
        this.submitSchoolForm();
        this.updateTraining();
        this.deleteTraining();
        this.submitTrainingForm();
        this.openFeatured();
        this.submitFeaturedForm();
        this.getMoreExperiences();
        this.computeUiTitlesSeparator();
        this.addActorToCasting();
        this.askProfileValidation();
        this.setColumnsMinHeight();
        this.preparePrint();
        this.mobileScrollToGallery();
        this.contactActor();
    }).bind(this));

    // $.fn.matchHeight._maintainScroll = true;
};

FrontActorsSingle.prototype = {
    justLoadPage: true,
    lockAjaxForm: false,
    lockAjaxCasting: false,
    lockAjaxAskProfileValidation: false,
    lockAjaxCheckProfileCompleted: false,

    /**
     * Conditional fields.
     *
     * Display a field or a div depending on the value of another field.
     */
    setConditionalFields: function () {
        // Conditional input: residence permit
        conditionalFields.onChange($('#nationality'), $('#residence-permit'), 'ch', '!=');

        // Conditional input: file/media ID card
        conditionalFields.onChange($('#nationality'), $('#id-card'), 'ch', '==');

        // Conditional input: file/media proof of address
        conditionalFields.onChange($('#nationality'), $('#proof-of-address'), 'ch', '!=');

        // Conditional input: file/media residence permit file
        conditionalFields.onChange($('#nationality'), $('#residence-permit-file'), 'ch', '!=');

        // Conditional input: work status (other)
        conditionalFields.onChange($('#work-status'), $('#work-status-other'), 'other', '==');

        // Conditional input: canton
        conditionalFields.onChange($('#address-country'), $('#address-canton'), 'ch', '==');

        // Conditional input: skin (other)
        conditionalFields.onChange($('#skin'), $('#skin-other'), 'other', '==');

        // Conditional input: driver's licence
        conditionalFields.onChange($('input.drivers-licence[type=checkbox][value=other]'), $('#drivers-licence-other'), 'other', '==');

        // Conditional input: show hair-type only for men
        conditionalFields.onChange($('#sexe_ref'), $('#hair-type'), 'm', '==');
        $('#hair-type').formSelect();

        if ($('input.drivers-licence[type=checkbox][value=other]').is(":checked") || $('#drivers-licence-other').val().length > 1) {
            $('#drivers-licence-other').parent().removeClass('hidden');
        } else {
            $('#drivers-licence-other').parent().addClass('hidden');
        }
    },

    hoverMainPicture: function () {
        $('#actor .parent-image').mouseover(function () {
            $(this).find('.hover-featured').removeClass('hidden')
        });

        $('#actor .parent-image').mouseout(function () {
            $(this).find('.hover-featured').addClass("hidden");
        });

        $('#edit-feat').mouseover(function () {
            $(this).parents('.hover-featured').animate({
                opacity: 1,
            }, 1000);
        });

        $('#edit-feat').mouseout(function () {
            $(this).parents('.hover-featured').animate({
                opacity: 0.7,
            }, 1000);
        });
    },

    /**
     * Improve element's position
     */
    computeUiElementsPosition: function () {
        this.justLoadPage = true;

        setTimeout(function () {
            this.justLoadPage = false;
        }, 500);

        // Equal columns heights for entry-content and sidebar

        //$('#actor > .wrapper > .col').matchHeight();
        //$.fn.matchHeight._maintainScroll = true;
    },

    initSideNav: function () {
        var self = this;
        // Initialize
        $("#wrapper .sidenav").sidenav({
            edge: 'right',
            draggable: false,
            onCloseEnd	: self.onSideNavClose,
            onCloseStart: self.onBeforeClose
        });

        // Close the side nav 
        $(".close-side").on('click', function () {
            $("#wrapper .sidenav").sidenav('close');
        });

        // NEWS
        // Open the side nav and allow to do some things before
        $('#add-a-news').on('click', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            // Make category select enabled
            $('#edition-news #category').prop('disabled', false);

            // Clean experience index
            $('#edition-news [name=newsIndex]').val('');

            // Update title
            var newTitle = $('#add-news .nav-title').data('new');
            $('#add-news .nav-title').html(newTitle);

            $('#add-news #delete-news').addClass('hidden');
            $('#info-event-news').removeClass('hidden');

            // Clean form
            self.cleanForm($('#edition-news'));
            self.prepareNewsFields('theatre');

            // Get events with the actor's name mentionned
            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_linked_events',
                    security: comedien.security,
                    actorId: $('#edition-news [name=actorId]').val(),
                }
            }).done(function (response) {
                if (response.success) {
                    $('#add-news .events-actor').html('');
                    $('#add-news .events-actor').append(response.data.html);

                    // Open side nav
                    $('.button-collapse[data-target="add-news"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        // EXPERIENCES
        // Open the side nav and allow to do some things before
        // TODO: this needs to grab experience label from the small clicked button (+)
        $('.btn-add-exp').on('click', function () {
            // Make category select enabled
            $('#edition-experience #category').prop('disabled', false);

            // Clean experience index
            $('#edition-experience [name=experienceIndex]').val('');

            // Update title
            var newTitle = $('#add-experience .nav-title').data('new');
            $('#add-experience .nav-title').html(newTitle);
            // Clean form
            self.cleanForm($('#edition-experience'));
            setTimeout(function () {
                var category = 'theatre';
                self.prepareExperienceFields(category);
                if (category !== '') {
                    $('#edition-experience #category').val(category).trigger('change');
                    $('#edition-experience #category').formSelect();
                }
            }, 1000);

            // Open side nav
            $('.button-collapse[data-target="add-experience"]').trigger('click');
            // Pre-fill the category (if available)

        });

        // LANGUAGES
        // Open the side nav and allow to do some things before
        $('#add-lang').on('click', function () {

            // Clean experience index
            $('#edition-languages [name=langIndex]').val('');

            // Clean form
            self.cleanForm($('#edition-languages'));

            // Open side nav
            $('.button-collapse[data-target="add-language"]').trigger('click');
        });

        // SCHOOLS
        // Open the side nav and allow to do some things before
        $('#add-sch').on('click', function () {

            // Clean experience index
            $('#edition-school [name=schoolIndex]').val('');

            // Update title
            var newTitle = $('#add-school .nav-title').data('new');
            $('#add-school .nav-title').html(newTitle);

            $('#edition-school .wrapper-diploma').removeClass('hidden');
            $('#edition-school #get-diploma').parent().addClass("hidden");
            $('#edition-school #get-diploma').val('');

            // Clean form
            self.cleanForm($('#edition-school'));

            // Open side nav
            $('.button-collapse[data-target="add-school"]').trigger('click');
        });

        // TRAININGS
        // Open the side nav and allow to do some things before
        $('#add-train').on('click', function () {

            // Clean experience index
            $('#edition-training [name=trainingIndex]').val('');

            // Update title
            var newTitle = $('#add-training .nav-title').data('new');
            $('#add-training .nav-title').html(newTitle);

            // Clean form
            self.cleanForm($('#edition-training'));

            // Open side nav
            $('.button-collapse[data-target="add-training"]').trigger('click');
        });

        // SKILLS
        // Open the side nav and allow to do some things before
        $('#add-sk').on('click', function () {

            // Clean experience index
            $('#edition-skills [name=langIndex]').val('');

            // Clean form
            self.cleanForm($('#edition-skills'));

            // Open side nav
            $('.button-collapse[data-target="add-skill"]').trigger('click');
        });

        // PERSONAL DATA
        // Open the side nav and allow to do some things before
        $('.single-cm-actors').on('click', '.add-pers-data', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var partName = $(this).data('part');

            var submittedForm = $('#edition-personal-data');

            submittedForm.find('.part').addClass('hidden');
            submittedForm.find('.part.' + partName).removeClass('hidden');

            submittedForm.find('.part.' + partName).find('.required').each(function() {
                $(this).prop('required', true);
            });

            // Get the profile
            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_profile',
                    security: comedien.security,
                    actorId: submittedForm.find('[name=actorId]').val(),
                }
            }).done(function (response) {
                if (response.success) {
                    var actorData = response.data.actorData;
                    var userData = response.data.userData;

                    $('.content-document .chip').remove();

                    submittedForm.find('#proof-of-address').parent().parent().find('.file-path-wrapper > .file-path').removeClass('valid');
                    submittedForm.find('#id-card').parent().parent().find('.file-path-wrapper > .file-path').removeClass('valid');
                    submittedForm.find('#residence-permit-file').parent().parent().find('.file-path-wrapper > .file-path').removeClass('valid');

                    // Fill the fields
                    for (var key in actorData) {
                        if (actorData[key] === true || actorData[key] === false || (actorData[key] !== null && actorData[key] !== undefined) || (actorData[key] != null && actorData[key].length > 0)) {
                            if (key === 'sexe' || key === 'nationality' || key === 'nationality-dual' || key === 'residence-permit' || key === 'work-status' || key === 'social-compagnie') {
                                // Select
                                submittedForm.find('#' + key).find('option[value="' + actorData[key] + '"]').prop('selected', true);
                                submittedForm.find('#' + key).formSelect();

                                if (key === 'social-compagnie' && actorData[key] == 'other') {
                                    $('.input-field-compagnie-other').show();
                                }
                            } else if (key === 'birthdate') {
                                if (actorData[key].length > 0) {
                                    // Date
                                    var dateArray = actorData[key].split("-");
                                    var date = dateArray[2] + "." + dateArray[1] + "." + dateArray[0];
                                    submittedForm.find('#' + key).val(date);
                                    submittedForm.find('[name=_submit]').val(actorData[key]);
                                    submittedForm.find('label[for=' + key + ']').addClass("active");

                                    $('#birthdate').datepicker({
                                        container: '#wrapper',
                                        format: 'dd.mm.yyyy',
                                        defaultDate: new Date(dateArray[0],dateArray[1]-1,dateArray[2]),
                                        setDefaultDate: true
                                    });
                                }
                            } else if (key === 'switzerland-inhabitant') {
                                submittedForm.find('input').prop('checked', false);

                                if (actorData[key]) {
                                    submittedForm.find('[name=' + key + '][value=yes]').prop('checked', true);
                                } else if (!actorData[key]) {
                                    submittedForm.find('[name=' + key + '][value=no]').prop('checked', true);
                                }
                            } else if (key === 'get-id-card') {
                                submittedForm.find('.content-document').append('<div class="chip id-card" data-type="document">' + actorData[key] + '<i class="material-icons close">close</i></div>')
                            } else if (key === 'get-residence-permit-file') {
                                submittedForm.find('.content-document').append('<div class="chip residence-permit-file" data-type="document">' + actorData[key] + '<i class="material-icons close">close</i></div>')
                            } else if (key === 'get-proof-of-address') {
                                submittedForm.find('.content-document').append('<div class="chip proof-address" data-type="document">' + actorData[key] + '<i class="material-icons close">close</i></div>')
                            } else {
                                submittedForm.find('#' + key).val(actorData[key]);
                                submittedForm.find('label[for=' + key + ']').addClass("active");
                            }
                        }

                        if ($('#nationality').val() !== 'ch') {
                            // Non swiss / foreigners
                            submittedForm.find('.content-document').find('.id-card').remove();
                            $('.wrapper-proof-of-address').removeClass("hidden");
                            $('.wrapper-residence-permit-file').removeClass("hidden");
                            $('.wrapper-id-card').addClass("hidden");
                        } else {
                            // Swiss only
                            submittedForm.find('.content-document').find('.proof-address').remove();
                            submittedForm.find('.content-document').find('.residence-permit-file').remove();
                            $('.wrapper-proof-of-address').addClass("hidden");
                            $('.wrapper-residence-permit-file').addClass("hidden");
                            $('.wrapper-id-card').removeClass("hidden");
                        }
                    }

                    // Fill the fields
                    for (var key in userData) {
                        if (userData[key].length > 0) {
                            if (key === 'address-country' || key === 'address-canton') {
                                // Select
                                submittedForm.find('#' + key).find('option[value="' + userData[key] + '"]').prop('selected', true);
                                submittedForm.find('#' + key).formSelect();
                            } else {
                                submittedForm.find('#' + key).val(userData[key]);
                                submittedForm.find('label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    // Open side nav
                    $('.button-collapse[data-target="add-personal-data"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        $(document).on('change', '#social-compagnie', function() {
            if ($(this).val() == 'other') {
                $('.input-field-compagnie-other').show();
            } else {
                $('.input-field-compagnie-other').hide();
                $('#social-compagnie-other').val('');
            }
        });

        $(document).on('click', '#social-compagnie-reset', function(e) {
            e.preventDefault();

            $('#social-compagnie').prop('selectedIndex', 0);
            $('#social-compagnie').formSelect();
            $('.input-field-compagnie-other').hide();
            $('#social-compagnie-other').val('');
        });
    },

    onSideNavClose: function(el) {
        if ($(el).attr('id') == 'sidebar-manage-photos' || $(el).attr('id') == 'sidebar-manage-videos' || $(el).attr('id') == 'sidebar-manage-audios') {
            //...
        }
    },

    onBeforeClose: function(el) {
        if ($(el).attr('id') == 'sidebar-manage-photos') {
            if ($('#sidebar-manage-photos input[name="mediaChanged"]').val() == 1) {
                $('#modal-confirm-exit-media-without-saving').removeClass('manage-photos').removeClass('manage-videos').removeClass('manage-audios');
                $('#modal-confirm-exit-media-without-saving').modal('open');
                $('#modal-confirm-exit-media-without-saving').addClass('manage-photos');
                return false;
            }
        }

        if ($(el).attr('id') == 'sidebar-manage-videos') {
            if ($('#sidebar-manage-videos input[name="mediaChanged"]').val() == 1) {
                $('#modal-confirm-exit-media-without-saving').removeClass('manage-photos').removeClass('manage-videos').removeClass('manage-audios');
                $('#modal-confirm-exit-media-without-saving').modal('open');
                $('#modal-confirm-exit-media-without-saving').addClass('manage-videos');
                return false;
            }
        }

        if ($(el).attr('id') == 'sidebar-manage-audios') {
            if ($('#sidebar-manage-audios input[name="mediaChanged"]').val() == 1) {
                $('#modal-confirm-exit-media-without-saving').removeClass('manage-photos').removeClass('manage-videos').removeClass('manage-audios');
                $('#modal-confirm-exit-media-without-saving').modal('open');
                $('#modal-confirm-exit-media-without-saving').addClass('manage-audios');
                return false;
            }
        }
    },

    /**
     * Initialize the Collapsible Materialize component.
     */
    initCollapsible: function () {
        var self = this;

        ui.initCollapsible(function() {
            self.setColumnsMinHeight();
        }, function() {
            self.setColumnsMinHeight();
        });
    },

    /**
     * Initialize images gallery.
     */
    initGallery: function () {
        $('#featured-image').on('click', function() {
            $('#gallery .image.hidden').find('a').trigger('click');
        });

        $('#see-actor-carousel').on('click', function() {
            $('#gallery .image.hidden').find('a').trigger('click');
        });

        $('article#actor .gallery img').each(function () {
            var src = $(this).attr("src");
            $(this).parent().attr("href", src);
        });

        $('article#actor #gallery').magnificPopup({
            delegate: '.image a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function (item) {
                    return item.el.find('img').parent().attr('data-caption');
                }
            },
            gallery: {
                enabled: true,
                preload: [0, 2],
                navigateByImgClick: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                tPrev: comedien.i18n.galleryButtonPrev, // title for left button
                tNext: comedien.i18n.galleryButtonNext, // title for right button
                tCounter: '<span class="mfp-counter">%curr% ' + comedien.i18n.galleryCounter + ' %total%</span>'
            },
            zoom: {
                enabled: true,
                duration: 300, // NB: also change the duration in CSS!
                opener: function (element) {
                    return element.find('img');
                }
            }
        });

        // Mobile gallery

        $('article#actor #gallery-mobile .images').slick({
            dots: false,
            infinite: false,
            arrows: false,
            //mobileFirst: true,
            //variableWidth: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 330,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $('article#actor #gallery-mobile .images').magnificPopup({
            delegate: '.image a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function (item) {
                    return item.el.find('img').parent().attr('data-caption');
                }
            },
            gallery: {
                enabled: true,
                preload: [0, 2],
                navigateByImgClick: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                tPrev: comedien.i18n.galleryButtonPrev, // title for left button
                tNext: comedien.i18n.galleryButtonNext, // title for right button
                tCounter: '<span class="mfp-counter">%curr% ' + comedien.i18n.galleryCounter + ' %total%</span>'
            },
            zoom: {
                enabled: true,
                duration: 300, // NB: also change the duration in CSS!
                opener: function (element) {
                    return element.find('img');
                }
            }
        });
    },

    /**
     * Prepare ajax request for "more experiences" button
     */
    getMoreExperiences: function () {
        $('.single-cm-actors').on('click', 'a.more-exp', function() {
            var link = $(this);

            var idPost = link.attr('data-idpost');
            var type = link.attr('data-exp');
            var offset = link.attr('data-offset');
            var order = link.attr('data-order');
            var total = link.attr("data-total");

            if (typeof link.attr('data-number') !== 'undefined') {
                var number = link.attr('data-number');
            } else {
                var number = false;
            }

            // For scroll after experience loading (except for award experiences)
            if (type !== 'award') {
                var exp = link.parents('.experience-type').find('article');
                var no_exp = (link.parents('.experience-type').find('article').length) - 2;
                exp.eq(no_exp).attr("id", "scroll-to");
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.more_experiences',
                    security: comedien.security,
                    idPost: idPost,
                    type: type,
                    offset: offset,
                    number: number,
                    order: order
                }
            }).done(function (response) {
                if (response.success) {
                    link.parent().before(response.data.items);

                    if (number && link.parents('.experience-type').find('article').length < total) {
                        // if there are as many experiences as planned, the offset is updated
                        var planned_offset = parseInt(number) + parseInt(offset);
                        link.attr('data-offset', planned_offset);
                    } else {
                        // else it means there is no more experiences to display
                        link.parent().addClass("hidden");
                        var new_offset = link.attr("data-total");
                        link.attr('data-offset', new_offset);
                    }

                    // Update height of columns
                    //$('article#actor .wrapper > .col').css("height", "initial");
                    //$('article#actor .wrapper > .col').matchHeight();

                    // Scroll to element
                    if ($('#scroll-to').length > 0) {
                        location.href = "#";
                        location.href = "#scroll-to";
                        $('#scroll-to').removeAttr('id');
                    }
                } else {
                    // TODO: display a msg on screen
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    prepareNewsFields: function (valueSelected) {
        var self = this;

        if (valueSelected !== undefined) {

            $('#edition-news').find('.no-other').removeClass('hidden');
            $('#edition-news').find('.no-other.required').find('input').prop('required', true);

            $('#edition-news').find('.input-field:not(.base)').addClass('hidden');
            $('#edition-news').find('.input-field:not(.base)').find('input').prop('required', false);

            if (valueSelected === 'realisation' || valueSelected === 'voices' || valueSelected === 'writing' ||
                valueSelected === 'other' || valueSelected === 'award') {

                $('#edition-news').find('.common').removeClass('hidden');
                $('#edition-news').find('.common.required').find('input').prop('required', true);
            }

            if (valueSelected === 'theatre') {
                $('#edition-news').find('.theatre').removeClass('hidden');
                $('#edition-news').find('.theatre.required').find('input').prop('required', true);
            } else if (valueSelected === 'cinema') {
                $('#edition-news').find('.cinema').removeClass('hidden');
                $('#edition-news').find('.cinema.required').find('input').prop('required', true);
            } else if (valueSelected === 'television') {
                $('#edition-news').find('.television').removeClass('hidden');
                $('#edition-news').find('.television.required').find('input').prop('required', true);
            } else if (valueSelected === 'standup') {
                $('#edition-news').find('.standup').removeClass('hidden');
                $('#edition-news').find('.standup.required').find('input').prop('required', true);
            } else if (valueSelected === 'contes') {
                $('#edition-news').find('.contes').removeClass('hidden');
                $('#edition-news').find('.contes.required').find('input').prop('required', true);
            } else if (valueSelected === 'improvisation') {
                $('#edition-news').find('.improvisation').removeClass('hidden');
                $('#edition-news').find('.improvisation.required').find('input').prop('required', true);
            } else if (valueSelected === 'short-film') {
                $('#edition-news').find('.shortfilm').removeClass('hidden');
                $('#edition-news').find('.shortfilm.required').find('input').prop('required', true);
            } else if (valueSelected === 'web') {
                $('#edition-news').find('.web').removeClass('hidden');
                $('#edition-news').find('.web.required').find('input').prop('required', true);
            } else if (valueSelected === 'musical') {
                $('#edition-news').find('.musical').removeClass('hidden');
                $('#edition-news').find('.musical.required').find('input').prop('required', true);
            } else if (valueSelected === 'opera') {
                $('#edition-news').find('.opera').removeClass('hidden');
                $('#edition-news').find('.opera.required').find('input').prop('required', true);
            } else if (valueSelected === 'ad') {
                $('#edition-news').find('.ads').removeClass('hidden');
                $('#edition-news').find('.ads.required').find('input').prop('required', true);
            } else if (valueSelected === 'mises-en-scene') {
                $('#edition-news').find('.miseenscene').removeClass('hidden');
                $('#edition-news').find('.miseenscene.required').find('input').prop('required', true);
            } else if (valueSelected === 'reading') {
                $('#edition-news').find('.reading').removeClass('hidden');
                $('#edition-news').find('.reading.required').find('input').prop('required', true);
            } else if (valueSelected === 'teaching') {
                $('#edition-news').find('.teaching').removeClass('hidden');
                // $('#edition-news').find('.teaching.required').find('input').prop('required', true);
            } else if (valueSelected === 'other') {
                $('#edition-news').find('.no-other').addClass('hidden');
                $('#edition-news').find('.no-other').find('input').prop('required', false);
            }

            $('#edition-news').find('.always').removeClass('hidden');

            $('#edition-news #place-performance').prop('required', false);
        }
    },

    prepareExperienceFields: function (valueSelected) {
        var self = this;

        if (valueSelected !== undefined) {
            $('#edition-experience #role').parent().find('label span.required').show();

            $('#edition-experience').find('.no-award').removeClass('hidden');
            $('#edition-experience').find('.no-award.required').find('input').prop('required', true);

            $('#edition-experience').find('.no-other').removeClass('hidden');
            $('#edition-experience').find('.no-other.required').find('input').prop('required', true);

            $('#edition-experience').find('.input-field:not(.base)').addClass('hidden');
            $('#edition-experience').find('.input-field:not(.base)').find('input').prop('required', false);

            if (valueSelected === 'realisation' || valueSelected === 'voices' || valueSelected === 'writing' ||
                valueSelected === 'other' || valueSelected === 'award') {

                $('#edition-experience').find('.common').removeClass('hidden');
                $('#edition-experience').find('.common.required').find('input').prop('required', true);
            }

            if (valueSelected === 'theatre') {
                $('#edition-experience').find('.theatre').removeClass('hidden');
                $('#edition-experience').find('.theatre.required').find('input').prop('required', true);
            } else if (valueSelected === 'cinema') {
                $('#edition-experience').find('.cinema').removeClass('hidden');
                $('#edition-experience').find('.cinema.required').find('input').prop('required', true);
            } else if (valueSelected === 'television') {
                $('#edition-experience').find('.television').removeClass('hidden');
                $('#edition-experience').find('.television.required').find('input').prop('required', true);
            } else if (valueSelected === 'standup') {
                $('#edition-experience').find('.standup').removeClass('hidden');
                $('#edition-experience').find('.standup.required').find('input').prop('required', true);
                $('#edition-experience #role').removeAttr('required');
                $('#edition-experience #role').parent().find('label span.required').hide();
            } else if (valueSelected === 'contes') {
                $('#edition-experience').find('.contes').removeClass('hidden');
                $('#edition-experience').find('.contes.required').find('input').prop('required', true);
                $('#edition-experience #role').removeAttr('required');
                $('#edition-experience #role').parent().find('label span.required').hide();
            } else if (valueSelected === 'improvisation') {
                $('#edition-experience').find('.improvisation').removeClass('hidden');
                $('#edition-experience').find('.improvisation.required').find('input').prop('required', true);
                $('#edition-experience #role').removeAttr('required');
                $('#edition-experience #role').parent().find('label span.required').hide();
                $('#edition-experience #director').removeAttr('required');
                $('#edition-experience #director').parent().find('label span.required').hide();
            } else if (valueSelected === 'short-film') {
                $('#edition-experience').find('.shortfilm').removeClass('hidden');
                $('#edition-experience').find('.shortfilm.required').find('input').prop('required', true);
            } else if (valueSelected === 'web') {
                $('#edition-experience').find('.web').removeClass('hidden');
                $('#edition-experience').find('.web.required').find('input').prop('required', true);
            } else if (valueSelected === 'musical') {
                $('#edition-experience').find('.musical').removeClass('hidden');
                $('#edition-experience').find('.musical.required').find('input').prop('required', true);
            } else if (valueSelected === 'opera') {
                $('#edition-experience').find('.opera').removeClass('hidden');
                $('#edition-experience').find('.opera.required').find('input').prop('required', true);
            } else if (valueSelected === 'ad') {
                $('#edition-experience').find('.ads').removeClass('hidden');
                $('#edition-experience').find('.ads.required').find('input').prop('required', true);
            } else if (valueSelected === 'mises-en-scene') {
                $('#edition-experience').find('.miseenscene').removeClass('hidden');
                $('#edition-experience').find('.miseenscene.required').find('input').prop('required', true);
            } else if (valueSelected === 'reading') {
                $('#edition-experience').find('.reading').removeClass('hidden');
                $('#edition-experience').find('.reading.required').find('input').prop('required', true);
            } else if (valueSelected === 'teaching') {
                $('#edition-experience').find('.teaching').removeClass('hidden');
                $('#edition-experience').find('.teaching.required').find('input').prop('required', true);
            } else if (valueSelected === 'other') {
                $('#edition-experience').find('.no-other').addClass('hidden');
                $('#edition-experience').find('.no-other').find('input').prop('required', false);
            } else if (valueSelected === 'award') {
                $('#edition-experience').find('.award').removeClass('hidden');
                $('#edition-experience').find('.award.required').find('input').prop('required', true);

                $('#edition-experience').find('.no-award').addClass('hidden');
                $('#edition-experience').find('.no-award').find('input').prop('required', false);
            }

            $('#edition-experience #place-performance').prop('required', false);
        }
    },

    newsSelectFields: function () {
        var self = this;

        $('#edition-news').find('#category').change(function () {
            var selectToUpdate = $(this);
            var valueSelected = selectToUpdate.val();

            self.prepareNewsFields(valueSelected);
        });
    },

    updateNews: function () {
        var self = this;

        var form = $('#edition-news');

        $('.single-cm-actors').on('click', '.edit-news', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.item').data('index');
            var categoryValue = $(this).parents('.item').data('type');

            form.find('[name=newsIndex]').val(indexValue);
            form.find('[name=newsType]').val(categoryValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_news',
                    security: comedien.security,
                    actorId: form.find('[name=actorId]').val(),
                    index: indexValue,
                    category: categoryValue,
                }
            }).done(function (response) {
                if (response.success) {
                    var editTitle = $('#add-news .nav-title').data('edit');
                    $('#add-news .nav-title').html(editTitle);

                    $('#add-news #delete-news').removeClass('hidden');
                    $('#info-event-news').addClass('hidden');
                    $('.events-actor').html('');

                    self.prepareNewsFields(categoryValue);

                    self.cleanForm(form);

                    // Update category select
                    form.find('#category').find('option[value="' + categoryValue + '"]').prop('selected', true);
                    form.find('#category').formSelect();

                    var item = response.data.item;

                    // Fill the fields
                    for (var key in item) {
                        if (item[key].length > 0) {
                            if (key === 'role-ranking' || key === 'year-ongoing') {
                                form.find('[name=news-' + key + '][value=' + item[key] + ']').prop('checked', true);
                            } else if (key === 'title') {
                                if (categoryValue == 'cinema' || categoryValue == 'short-film') {
                                    var newKey = 'cinema-title';
                                } else if (categoryValue == 'television') {
                                    var newKey = 'tv-title';
                                } else if (categoryValue == 'ad') {
                                    var newKey = 'ads-title';
                                } else if (categoryValue == 'web') {
                                    var newKey = 'web-title';
                                } else if (categoryValue == 'realisation' || categoryValue == 'voices' ||
                                    categoryValue == 'writing' || categoryValue == 'other' || categoryValue == 'award'
                                    || categoryValue == 'mises-en-scene') {
                                    var newKey = 'common-title';
                                } else {
                                    var newKey = 'title';
                                }

                                form.find('#news-' + newKey).val(item[key]);
                                form.find('label[for=news-' + newKey + ']').addClass("active");
                            } else if (key === 'director') {
                                if (categoryValue == 'cinema' || categoryValue == 'short-film' || categoryValue == 'ad'
                                    || categoryValue == 'television' || categoryValue == 'web') {
                                    var newKey = 'cinema-director';
                                } else {
                                    var newKey = 'director';
                                }

                                form.find('#news-' + newKey).val(item[key]);
                                form.find('label[for=news-' + newKey + ']').addClass("active");
                            } else if (key === 'channel') {
                                if (categoryValue == 'web') {
                                    var newKey = 'web-channel';
                                } else if (categoryValue == 'television') {
                                    var newKey = 'tv-channel';
                                }

                                form.find('#news-' + newKey).val(item[key]);
                                form.find('label[for=news-' + newKey + ']').addClass("active");
                            } else if (key === 'year') {
                                form.find('#news-year').find('option[value="' + item[key] + '"]').prop('selected', true);
                                form.find('#news-year').formSelect();
                            } else {
                                form.find('#news-' + key).val(item[key]);
                                form.find('label[for=news-' + key + ']').addClass("active");
                            }
                        }
                    }

                    if (form.find('[name=news-role-ranking]:checked').length < 1) {
                        form.find('#news-role-hide[name=role-ranking]').prop('checked', true);
                    }

                    $('.button-collapse[data-target="add-news"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteNews: function () {
        $('#edition-news #delete-news').on('click', function () {
            var indexValue = $('#edition-news [name=newsIndex]').val();
            var categoryValue = $('#edition-news [name=newsType]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_news',
                    security: comedien.security,
                    actorId: $('#edition-news [name=actorId]').val(),
                    index: indexValue,
                    category: categoryValue,
                }
            }).done(function (response) {
                if (response.success) {
                    var newsToDelete = $('.items [data-type="' + categoryValue + '"][data-index="' + indexValue + '"]');
                    newsToDelete.remove();

                    $('#edition-news [name=newsType]').val('');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                } else {
                    // TODO: display a msg on screen
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitEventNewsForm: function () {
        var self = this;

        $('.single-cm-actors').on('submit', '#add-news form#events-news', function (event) {
            var form = $(this);

            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);

                formdata.append('action', 'actors.add_event_news');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : form.serialize() + "&actors.add_event_news.form&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    // Remove all event news
                    $('.item.event-news').next('.divider').remove();
                    $('.item.event-news').remove();

                    // Add all events in front
                    var htmlArray = response.data.html;
                    for (var key in htmlArray) {
                        if (htmlArray[key].length > 0) {
                            $('.items').prepend(htmlArray[key]);
                        }
                    }

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                // $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitNewsForm: function () {
        var self = this;

        var form = $('#edition-news');

        form.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();
            $('.preloader-wrapper', form).fadeIn();

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);

                formdata.append('action', 'actors.edit_news');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : form.serialize() + "&actors.edit_news.form&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,

            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingNews) {
                        var newsToUpdate = $('.items [data-type="' + response.data.category + '"][data-index="' + response.data.existingNews + '"]');
                        newsToUpdate.after(response.data.html);
                        newsToUpdate.remove();
                    } else {
                        var parent = $('.news .items');
                        parent.prepend(response.data.html);
                    }

                    self.cleanForm(form);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Prepare ajax request for "more news" button
     */
    getMoreNews: function () {
        var self = this;

        $('a.more-news').click(function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var link = $(this);

            var idPost = link.data('idpost');
            var offset = link.attr('data-offset');
            var order = link.data('order');
            var total = link.data('total');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.more_news',
                    security: comedien.security,
                    idPost: idPost,
                    offset: offset,
                    order: order
                }
            }).done(function (response) {
                if (response.success) {
                    var htmlArray = response.data.html;

                    for (var key in htmlArray) {
                        $('.items').append(htmlArray[key]);
                    }

                    if (parseInt(offset) + htmlArray.length < total) {
                        // if there are as many experiences as planned, the offset is updated
                        var planned_offset = parseInt(offset) + htmlArray.length;
                        link.attr('data-offset', planned_offset);
                    } else {
                        link.parent().addClass("hidden");
                        var new_offset = link.attr("data-total");
                        link.attr('data-offset', new_offset);
                    }

                    // Update height of columns
                    //$('article#actor .wrapper > .col').css("height", "initial");
                    //$('article#actor .wrapper > .col').matchHeight();
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    experienceSelectFields: function () {
        var self = this;

        $('#edition-experience').find('#category').change(function () {
            var selectToUpdate = $(this);
            var valueSelected = selectToUpdate.val();
            // Attempt at fixing category. Currenty not working.
            // $('#experienceItemType').val(valueSelected);
            self.prepareExperienceFields(valueSelected);
        });
    },

    validateExperienceForm: function (form) {
        var self = this;

        // Check year-start
        var checkYearStart = function () {
            var yearStart = form.find('#year-start');
            var input = yearStart.parent().find('input.select-dropdown');
            if (yearStart.val() !== undefined && yearStart.val() !== '' && yearStart.val() !== null && yearStart.val() !== '--') {
                input.addClass('valid');
                input.removeClass('invalid');
            } else {
                input.removeClass('valid');
                input.addClass('invalid');
            }
        };

        checkYearStart();

        form.find('#year-start').change(function () {
            checkYearStart();
        });

    },

    submitExperienceForm: function () {
        var self = this;
        var experienceForm = $('#edition-experience');
        self.validateExperienceForm(experienceForm);
        experienceForm.submit(function (event) {
            event.preventDefault();

            if (experienceForm.find('.invalid').length > 0) {
                return;
            }

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', experienceForm).hide();
            $('.preloader-wrapper', experienceForm).fadeIn();

            var ajaxAction = 'actors.edit_experience';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(experienceForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : experienceForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    $('.experience-type[data-type="'+ response.data.category +'"]').find('.year-box').remove();
                    $('.experience-type[data-type="'+ response.data.category +'"]').find('.more-box').remove();
                    $('.experience-type[data-type="'+ response.data.category +'"]').append(response.data.html);

                    $('#edition-experience [name=experienceIndex]').val('');
                    $('#edition-experience [name=experienceType]').val('');

                    self.cleanForm(experienceForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, experienceForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', experienceForm).fadeOut();
                $('#submit', experienceForm).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', experienceForm).fadeOut();
                $('#submit', experienceForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    cleanForm: function (form) {
        // Clean inputs
        form.find('[type=text]:not([type=hidden])').each(function () {
            $(this).val('');
        });

        // Clean radio buttons
        form.find('[type=radio]').each(function () {
            $(this).prop('checked', false);
        });

        // Clean textarea
        form.find('textarea').each(function () {
            $(this).val('');
        });

        // Initialize selects
        form.find('select').formSelect();
        form.find('select').find('[value=""]').prop('selected', true);
        form.find('select').formSelect();
    },

    updateExperience: function () {
        var self = this;

        $('.single-cm-actors').on('click', '.edit-experience', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.year-box').data('index');
            var categoryValue = $(this).parents('.experience-type').data('type');

            $('#edition-experience [name=experienceIndex]').val(indexValue);
            $('#edition-experience [name=experienceType]').val(categoryValue);
            // WIP
            $('#edition-experience #category').prop('disabled', true);
            $('#edition-experience #category').formSelect();
            $('#edition-experience [name=category]').val(categoryValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: { action: 'actors.get_experience',
                    security: comedien.security,
                    actorId: $('#edition-experience [name=actorId]').val(),
                    index: indexValue,
                    category: categoryValue
                }
            }).done(function (response) {
                if (response.success) {
                    var editTitle = $('#add-experience .nav-title').data('edit');
                    $('#add-experience .nav-title').html(editTitle);

                    $('#add-experience #delete-exp').removeClass('hidden');

                    self.prepareExperienceFields(categoryValue);

                    self.cleanForm($('#edition-experience'));

                    // Update category select
                    $('#edition-experience #category').find('option[value="' + categoryValue + '"]').prop('selected', true);
                    $('#edition-experience #category').formSelect();

                    var experience = response.data.experience;

                    // Fill the fields
                    for (var key in experience) {
                        if (experience[key].length > 0) {
                            if (key === 'year-start' || key === 'year-end' || key === 'month-start' || key === 'month-end') {
                                $('#edition-experience #' + key).find('option[value="' + experience[key] + '"]').prop('selected', true);
                                $('#edition-experience #' + key).formSelect();
                            } else if (key === 'role-ranking' || key === 'year-ongoing') {
                                $('#edition-experience [name=' + key + '][value=' + experience[key] + ']').prop('checked', true);
                            } else if (key === 'title') {
                                if (categoryValue == 'cinema' || categoryValue == 'short-film') {
                                    var newKey = 'cinema-title';
                                } else if (categoryValue == 'television') {
                                    var newKey = 'tv-title';
                                } else if (categoryValue == 'ad') {
                                    var newKey = 'ads-title';
                                } else if (categoryValue == 'web') {
                                    var newKey = 'web-title';
                                } else if (categoryValue == 'realisation' || categoryValue == 'voices' || categoryValue == 'writing' || categoryValue == 'other' || categoryValue == 'award' || categoryValue == 'reading') {
                                    var newKey = 'common-title';
                                } else {
                                    var newKey = 'title';
                                }

                                $('#edition-experience #' + newKey).val(experience[key]);
                                $('#edition-experience label[for=' + newKey + ']').addClass("active");
                            } else if (key === 'director') {
                                if (categoryValue == 'cinema' || categoryValue == 'short-film' || categoryValue == 'ad'
                                    || categoryValue == 'television' || categoryValue == 'web') {
                                    var newKey = 'cinema-director';
                                } else {
                                    var newKey = 'director';
                                }

                                $('#edition-experience #' + newKey).val(experience[key]);
                                $('#edition-experience label[for=' + newKey + ']').addClass("active");
                            } else if (key === 'channel') {
                                if (categoryValue == 'web') {
                                    var newKey = 'web-channel';
                                } else if (categoryValue == 'television') {
                                    var newKey = 'tv-channel';
                                }

                                $('#edition-experience #' + newKey).val(experience[key]);
                                $('#edition-experience label[for=' + newKey + ']').addClass("active");
                            } else if (key === 'year') {
                                $('#edition-experience #year').find('option[value="' + experience[key] + '"]').prop('selected', true);
                                $('#edition-experience #year').formSelect();
                            } else {
                                $('#edition-experience #' + key).val(experience[key]);
                                $('#edition-experience label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    if ($('#edition-experience [name=role-ranking]:checked').length < 1) {
                        $('#edition-experience #role-hide[name=role-ranking]').prop('checked', true);
                    }

                    $('.button-collapse[data-target="add-experience"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteExperience: function () {
        $('#edition-experience #delete-exp').on('click', function () {
            var indexValue = $('#edition-experience [name=experienceIndex]').val();
            var categoryValue = $('#edition-experience [name=experienceType]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_experience',
                    security: comedien.security,
                    actorId: $('#edition-experience [name=actorId]').val(),
                    index: indexValue,
                    category: categoryValue,
                }
            }).done(function (response) {
                if (response.success) {
                    $('.experience-type[data-type="'+ categoryValue +'"]').find('.year-box').remove();
                    $('.experience-type[data-type="'+ categoryValue +'"]').find('.more-box').remove();
                    $('.experience-type[data-type="'+ categoryValue +'"]').append(response.data.html);

                    $('#edition-experience [name=experienceIndex]').val('');
                    $('#edition-experience [name=experienceType]').val('');
                    $('#edition-experience #delete-exp').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },


    initDatepicker: function () {

        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        $('.input-field #birthdate').datepicker({
            container: '#wrapper',
            format: 'dd.mm.yyyy',
            minDate: new Date(1900, 1, 1),
            yearRange: [1900, 2019],
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onOpen: function(date) {
                // console.log(date)
            },
            onClose: function () {
                if (typeof this.date === 'undefined')
                    return;

                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }

                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('.input-field #birthdateDatetime').val(datetime);
                        $('.input-fiel #birthdate').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('.input-field #birthdateDatetime').val('');
                        $('.row-form #birthdate').removeClass('force-valid').addClass('force-invalid');
                    }
                    $('.input-field label[for="birthdate"]').addClass('active');
                } else {
                    $('.input-fiel #birthdateDatetime').val('');
                    $('.input-fiel #birthdate').removeClass('force-valid').addClass('force-invalid');
                    $('.input-field label[for="birthdate"]').removeClass('active');
                }
            },
        });

    },

    submitAddressesForm: function () {
        var self = this;

        var addressesForm = $('#edition-addresses');

        addressesForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', addressesForm).hide();
            $('.preloader-wrapper', addressesForm).fadeIn();

            var ajaxAction = 'actors.edit_addresses';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(addressesForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : addressesForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingAddr) {
                        var addrToUpdate = $('#other-adresses .row[data-index="' + response.data.existingExp + '"]');
                        addrToUpdate.after(response.data.html);
                        addrToUpdate.remove();
                    } else {
                        if ($('#other-adresses .row').length < 1) {
                            var parent = $('#other-adresses');
                            parent.append(response.data.html);
                        } else {
                            var count = parseInt($('#other-adresses .row').length) + 1;
                            var html = response.data.html;
                            html = html.replace('Adresse :', 'Adresse ' + count + ':');

                            $('#other-adresses .row').last().after(html);
                        }
                    }

                    self.cleanForm(addressesForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, addressesForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', addressesForm).fadeOut();
                $('#submit', addressesForm).show();
            }).fail(function (jqXHR, textStatus) {

                self.lockAjaxForm = false;

                $('.preloader-wrapper', addressesForm).fadeOut();
                $('#submit', addressesForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateAddress: function () {
        var self = this;

        var addressesForm = $('#edition-addresses');

        $('.single-cm-actors').on('click', '.edit-addr', function () {
            var indexValue = $(this).parent().parent().data('index');

            addressesForm.find('[name=addressIndex]').val(indexValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_address',
                    security: comedien.security,
                    actorId: addressesForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {
                    addressesForm.find('#delete-addr').removeClass('hidden');

                    self.cleanForm(addressesForm);

                    var address = response.data.address;

                    // Fill the fields
                    for (var key in address) {

                        if (address[key].length > 0) {

                            if (key === 'address-country' || key === 'address-canton') {
                                $('#edition-addresses #' + key).find('option[value="' + address[key] + '"]').prop('selected', true);
                                $('#edition-addresses #' + key).formSelect();

                            } else {
                                $('#edition-addresses #' + key).val(address[key]);
                                $('#edition-addresses label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    $('.button-collapse[data-target="add-other-addresses"]').trigger('click');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitCharacteristicsForm: function () {
        var self = this;

        var characForm = $('#edition-charac');

        characForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', characForm).hide();
            $('.preloader-wrapper', characForm).fadeIn();

            var ajaxAction = 'actors.edit_characteristics';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(characForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : characForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    var parent = $('.content-characteristics').parent();
                    $('.content-characteristics').remove();
                    parent.append(response.data.html);

                    self.cleanForm(characForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, characForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', characForm).fadeOut();
                $('#submit', characForm).show();
            }).fail(function (jqXHR, textStatus) {

                self.lockAjaxForm = false;

                $('.preloader-wrapper', characForm).fadeOut();
                $('#submit', characForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateCharacteristics: function () {
        var self = this;

        var characForm = $('#edition-charac');

        $('#add-charac').on('click', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_characteristics',
                    security: comedien.security,
                    actorId: characForm.find('[name=actorId]').val(),
                }
            }).done(function (response) {
                if (response.success) {
                    self.cleanForm(characForm);

                    var data = response.data.data;

                    var selects = [
                        'skin',
                        'skin-other',
                        'size',
                        'corpulence',
                        'hair-colors',
                        'hair-type',
                        'eye-color'
                    ]

                    // Fill the fields
                    for (var key in data) {
                        if (data[key] != null && data[key].length > 0) {
                            if (($.inArray(key, selects)) > -1) {
                                $('#edition-charac #' + key).find('option[value="' + data[key] + '"]').prop('selected', true);
                                $('#edition-charac #' + key).formSelect();
                            } else {
                                $('#edition-charac #' + key).val(data[key]);
                                $('#edition-charac label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    // Open side nav
                    $('.button-collapse[data-target="add-characteristics"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitAgencyForm: function () {
        var self = this;

        var agencyForm = $('#edition-agency');

        agencyForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', agencyForm).hide();
            $('.preloader-wrapper', agencyForm).fadeIn();

            var ajaxAction = 'actors.edit_agency';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(agencyForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : agencyForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    var parent = $('.content-agency').parent();
                    $('.content-agency').remove();
                    parent.append(response.data.html);

                    self.cleanForm(agencyForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, agencyForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', agencyForm).fadeOut();
                $('#submit', agencyForm).show();

            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', agencyForm).fadeOut();
                $('#submit', agencyForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateAgency: function () {
        var self = this;

        var agencyForm = $('#edition-agency');

        $('#add-ag').on('click', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_agency',
                    security: comedien.security,
                    actorId: agencyForm.find('[name=actorId]').val(),
                }
            }).done(function (response) {
                if (response.success) {
                    self.cleanForm(agencyForm);

                    var data = response.data.data;

                    // Fill the fields
                    for (var key in data) {
                        if (data[key].length > 0) {
                            if (key === 'agency-address-country') {
                                $('#edition-agency #' + key).find('option[value="' + data[key] + '"]').prop('selected', true);
                                $('#edition-agency #' + key).formSelect();

                            } else {
                                $('#edition-agency #' + key).val(data[key]);
                                $('#edition-agency label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    // Open side nav
                    $('.button-collapse[data-target="add-agency"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteAddress: function () {
        $('#edition-addresses #delete-addr').on('click', function () {
            var addressesForm = $('#edition-addresses');
            var indexValue = addressesForm.find('[name=addressIndex]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_address',
                    security: comedien.security,
                    actorId: addressesForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {

                    var addrToDelete = $('#other-adresses .row[data-index="'+ indexValue +'"]');
                    addrToDelete.remove();
                    addressesForm.find('#delete-addr').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateLanguage: function () {
        var self = this;

        var langForm = $('#edition-languages');

        $('.single-cm-actors').on('click', '.edit-lang', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.edition-picto').parent().data('index');

            langForm.find('[name=langIndex]').val(indexValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_lang',
                    security: comedien.security,
                    actorId: langForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {
                    // var editTitle = $('#add-experience .nav-title').data('edit');
                    // $('#add-experience .nav-title').html(editTitle);

                    $('#add-language #delete-lang').removeClass('hidden');

                    self.cleanForm(langForm);

                    var lang = response.data.lang;

                    if ((lang.lang).startsWith('other-custom-') && lang['lang-other'] !== '') {
                        // Other lang

                        $('#input-field-lang-other').show();

                        // Populate the lang dropdown
                        $('#edition-languages #lang').find('option[value="other"]').prop('selected', true);
                        $('#edition-languages #lang').formSelect();

                        // Populate the level dropdown
                        $('#edition-languages #level').find('option[value="' + lang.level + '"]').prop('selected', true);
                        $('#edition-languages #level').formSelect();

                        // Populate the input field
                        $('#edition-languages #lang-other').val(lang['lang-other']);
                        $('#edition-languages #lang-other').parent().find('label').addClass('active');
                    } else {
                        // Normal lang

                        $('#input-field-lang-other').hide();

                        // Populate the lang dropdown
                        $('#edition-languages #lang').find('option[value="' + lang.lang + '"]').prop('selected', true);
                        $('#edition-languages #lang').formSelect();

                        // Populate the level dropdown
                        $('#edition-languages #level').find('option[value="' + lang.level + '"]').prop('selected', true);
                        $('#edition-languages #level').formSelect();

                        // Populate the input field
                        $('#edition-languages #lang-other').val('');
                    }

                    $('.button-collapse[data-target="add-language"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteLanguage: function () {
        $('#edition-languages #delete-lang').on('click', function () {
            var langForm = $('#edition-languages');
            var indexValue = langForm.find('[name=langIndex]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_lang',
                    security: comedien.security,
                    actorId: langForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {

                    var langToDelete = $('.content-languages').find('.col[data-index="'+ indexValue +'"]').parent()
                    var langToDelete = $('.content-languages').find('.col[data-index="' + indexValue + '"]').parent()
                    langToDelete.remove();

                    langForm.find('#delete-lang').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitLanguageForm: function () {
        var self = this;

        var langForm = $('#edition-languages');

        langForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', langForm).hide();
            $('.preloader-wrapper', langForm).fadeIn();

            var ajaxAction = 'actors.edit_lang';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(langForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : langForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingLang) {
                        var langToUpdate = $('.content-languages').find('.col[data-index="' + response.data.existingLang + '"]').parent();
                        langToUpdate.after(response.data.html);
                        langToUpdate.remove();
                    } else {
                        if ($('.content-languages .row').length < 1) {
                            var parent = $('.content-languages');
                            parent.append(response.data.html);
                        } else {
                            $('.content-languages .row').last().after(response.data.html);
                        }
                    }

                    $('#input-field-lang-other', langForm).hide();

                    self.cleanForm(langForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, langForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', langForm).fadeOut();
                $('#submit', langForm).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', langForm).fadeOut();
                $('#submit', langForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    addOtherLanguage: function() {
        $(document).on('change', '#edition-languages #lang', function() {
            if ($(this).val() === 'other') {
                $('#input-field-lang-other').show();
            } else {
                $('#input-field-lang-other').hide();
            }
        });
    },

    updateSkill: function () {
        var self = this;

        var skillForm = $('#edition-skills');

        $('.single-cm-actors').on('click', '.edit-skill', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.edition-picto').parent().data('index');

            skillForm.find('[name=skillIndex]').val(indexValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_skill',
                    security: comedien.security,
                    actorId: skillForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {
                    skillForm.find('#delete-skill').removeClass('hidden');

                    self.cleanForm(skillForm);

                    var skill = response.data.skill;

                    // Fill the fields
                    for (var key in skill) {
                        if (skill[key].length > 0) {
                            if (key === 'skill') {
                                $('#edition-skills #' + key).find('option[value="' + skill[key] + '"]').prop('selected', true);
                                $('#edition-skills #' + key).formSelect();
                            } else {
                                $('#edition-skills #' + key).val(skill[key]);
                                $('#edition-skills label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    $('.button-collapse[data-target="add-skill"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitSkillForm: function () {
        var self = this;

        var skillForm = $('#edition-skills');

        skillForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', skillForm).hide();
            $('.preloader-wrapper', skillForm).fadeIn();

            var ajaxAction = 'actors.edit_skill';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(skillForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : skillForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingSkill) {
                        var skillToUpdate = $('.content-skills').find('.col[data-index="'+ response.data.existingSkill +'"]').parent();
                        skillToUpdate.after(response.data.html);
                        skillToUpdate.remove();
                    } else {
                        if ($('.content-skills .row').length < 1) {
                            var parent = $('.content-skills');
                            parent.append(response.data.html);
                        } else {
                            $('.content-skills .row').last().after(response.data.html);
                        }
                    }

                    self.cleanForm(skillForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, skillForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', skillForm).fadeOut();
                $('#submit', skillForm).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', skillForm).fadeOut();
                $('#submit', skillForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteSkill: function () {
        $('#edition-skills #delete-skill').on('click', function () {
            var skillForm = $('#edition-skills');
            var indexValue = skillForm.find('[name=skillIndex]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_skill',
                    security: comedien.security,
                    actorId: skillForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {

                    var skillToDelete = $('.content-skills').find('.col[data-index="' + indexValue + '"]').parent()
                    skillToDelete.remove();
                    skillForm.find('#delete-skill').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitOtherSkillsForm: function () {
        var self = this;

        var otherSkillsForm = $('#edition-other-skills');

        otherSkillsForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', otherSkillsForm).hide();
            $('.preloader-wrapper', otherSkillsForm).fadeIn();

            var ajaxAction = 'actors.edit_other_skills';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(otherSkillsForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : otherSkillsForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    $('.content-other-skills').html('');

                    var newHtml = '';

                    var data = response.data.licences;
                    var other = response.data.other;

                    for (var key in data) {
                        if (key > 0) {
                            newHtml += ', ';
                        }

                        if (data[key] === 'Autre' && other.length > 0) {
                            newHtml += data[key] + ' (' + other + ')';
                        } else {
                            newHtml += data[key];
                        }
                    }

                    $('.content-other-skills').html(newHtml);

                    self.cleanForm(otherSkillsForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, otherSkillsForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', otherSkillsForm).fadeOut();
                $('#submit', otherSkillsForm).show();
            }).fail(function (jqXHR, textStatus) {

                self.lockAjaxForm = false;

                $('.preloader-wrapper', otherSkillsForm).fadeOut();
                $('#submit', otherSkillsForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateOtherSkills: function () {
        var self = this;

        var otherSkillsForm = $('#edition-other-skills');

        $('#add-other-sk').on('click', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_other_skills',
                    security: comedien.security,
                    actorId: otherSkillsForm.find('[name=actorId]').val(),
                }
            }).done(function (response) {
                if (response.success) {
                    self.cleanForm(otherSkillsForm);

                    var licences = response.data.licences;

                    // Fill the fields
                    for (var key in licences) {
                        $('#edition-other-skills #' + licences[key]).prop('checked', true);
                    }

                    var other = response.data.other;

                    $('#edition-other-skills #drivers-licence-other').val(other);
                    $('#edition-other-skills label[for=drivers-licence-other]').addClass("active");


                    // Open side nav
                    $('.button-collapse[data-target="add-other-skill"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateSchool: function () {
        var self = this;

        var schoolForm = $('#edition-school');

        $('.single-cm-actors').on('click', '.edit-school', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.item').data('index');

            schoolForm.find('[name=schoolIndex]').val(indexValue);

            schoolForm.find('.content-document .chip').remove();
            schoolForm.find('[name=deleteDocument]').val('');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_school',
                    security: comedien.security,
                    actorId: schoolForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {
                    schoolForm.find('#delete-school').removeClass('hidden');

                    $('#edition-school .wrapper-diploma').removeClass('hidden');
                    $('#edition-school [name=get-diploma]').parent().addClass("hidden");
                    $('#edition-school [name=get-diploma]').val('');
                    $('#edition-school .file-path').removeClass('valid');

                    self.cleanForm(schoolForm);

                    var school = response.data.school;

                    // Fill the fields
                    for (var key in school) {
                        if (school[key] != null || school[key] !== undefined|| school[key].length > 0) {
                            if (key === 'type' || key === 'year-start' || key === 'year-end' || key === 'country') {
                                $('#edition-school #' + key).find('option[value="' + school[key] + '"]').prop('selected', true);
                                $('#edition-school #' + key).formSelect();
                            } else if (key === 'year-ongoing' || key === 'graduated') {
                                $('#edition-school [name=' + key + '][value=' + school[key] + ']').prop('checked', true);
                            } else if (key === 'get-diploma') {
                                schoolForm.find('.content-document').append('<div class="chip" data-type="document">' + school[key] + '<i class="material-icons close">close</i></div>');
                            } else {
                                $('#edition-school #' + key).val(school[key]);
                                $('#edition-school label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    $('.button-collapse[data-target="add-school"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteSchool: function () {
        $('#edition-school #delete-school').on('click', function () {

            var indexValue = $('#edition-school [name=schoolIndex]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_school',
                    security: comedien.security,
                    actorId: $('#edition-school [name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {

                    var schoolToDelete = $('.content-schools').find('.item[data-index="'+ indexValue +'"]');
                    schoolToDelete.remove();

                    $('#edition-school #delete-school').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitSchoolForm: function () {
        var self = this;

        var schoolForm = $('#edition-school');

        schoolForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', schoolForm).hide();
            $('.preloader-wrapper', schoolForm).fadeIn();

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(schoolForm[0]);

                formdata.append('action', 'actors.edit_school');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : schoolForm.serialize() + "&action=edit_school&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingSchool) {
                        var schoolToUpdate = $('.content-schools').find('.item[data-index="'+ response.data.existingSchool +'"]');
                        schoolToUpdate.after(response.data.html);
                        schoolToUpdate.remove();
                    } else {

                        var lastSchool = $('.content-schools').find('.item').last();
                        if (lastSchool.length < 1) {
                            $('.content-schools').append(response.data.html);
                        } else {
                            lastSchool.after(response.data.html);
                        }
                    }

                    self.cleanForm(schoolForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, schoolForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', schoolForm).fadeOut();
                $('#submit', schoolForm).show();
            }).fail(function (jqXHR, textStatus) {

                self.lockAjaxForm = false;

                $('.preloader-wrapper', schoolForm).fadeOut();
                $('#submit', schoolForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitTrainingForm: function () {
        var self = this;

        var trainingForm = $('#edition-training');

        trainingForm.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', trainingForm).hide();
            $('.preloader-wrapper', trainingForm).fadeIn();

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(trainingForm[0]);

                formdata.append('action', 'actors.edit_training');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : trainingForm.serialize() + "&action=actors.edit_training&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    if (response.data.existingTraining) {
                        var trainingToUpdate = $('.content-trainings').find('.item[data-index="'+ response.data.existingTraining +'"]');
                        trainingToUpdate.after(response.data.html);
                        trainingToUpdate.remove();
                    } else {

                        var lastTraining = $('.content-trainings').find('.item').last();

                        if (lastTraining.length < 1) {
                            $('.content-trainings').append(response.data.html);
                        } else {
                            lastTraining.after(response.data.html);
                        }
                    }

                    self.cleanForm(trainingForm);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, trainingForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', trainingForm).fadeOut();
                $('#submit', trainingForm).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', trainingForm).fadeOut();
                $('#submit', trainingForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    deleteTraining: function () {
        $('#edition-training #delete-training').on('click', function () {
            var indexValue = $('#edition-training [name=trainingIndex]').val();

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.delete_training',
                    security: comedien.security,
                    actorId: $('#edition-training [name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {

                    var schoolToDelete = $('.content-trainings').find('.item[data-index="'+ indexValue +'"]');
                    schoolToDelete.remove();

                    $('#edition-training #delete-training').addClass('hidden');

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                }
            }).fail(function (jqXHR, textStatus) {
                // TODO
                console.log("Request failed: " + textStatus);
            });
        });
    },

    updateTraining: function () {
        var self = this;

        var trainingForm = $('#edition-training');

        $('.single-cm-actors').on('click', '.edit-training', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request
                return;
            }

            self.lockAjaxForm = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var indexValue = $(this).parents('.item').data('index');

            trainingForm.find('[name=trainingIndex]').val(indexValue);

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'actors.get_training',
                    security: comedien.security,
                    actorId: trainingForm.find('[name=actorId]').val(),
                    index: indexValue,
                }
            }).done(function (response) {
                if (response.success) {
                    trainingForm.find('#delete-training').removeClass('hidden');

                    self.cleanForm(trainingForm);

                    var training = response.data.training;

                    // Fill the fields
                    for (var key in training) {
                        if (training[key] != null || training[key].length > 0) {
                            if (key === 'year') {
                                $('#edition-training #training-year').find('option[value="' + training[key] + '"]').prop('selected', true);
                                $('#edition-training #training-year').formSelect();
                            } else if (key === 'description') {
                                $('#edition-training #training-description').val(training[key]);
                                $('#edition-training label[for=training-description]').addClass("active");
                            } else {
                                $('#edition-training #' + key).val(training[key]);
                                $('#edition-training label[for=' + key + ']').addClass("active");
                            }
                        }
                    }

                    $('.button-collapse[data-target="add-training"]').trigger('click');
                }

                self.lockAjaxForm = false;

                $('.toastLoading').fadeOut(500, function() {
                    $('.toastLoading').remove();
                });
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    validatePersonalDataForm: function(form) {
        var self = this;
        var part = form.find('.part:not(.hidden)');

        if (part.hasClass('identity')) {
            var checkNationality = function () {
                var nationality = form.find('#nationality');
                var input = nationality.parent().find('input.select-dropdown');
                if (nationality.val() !== undefined && nationality.val() !== '' && nationality.val() !== null && nationality.val() !== '--') {
                    input.removeClass('invalid');
                } else {
                    input.addClass('invalid');
                }
            };
            checkNationality();

            var checkBirthdate = function() {
                var input = form.find('#birthdate');
                if (input.val().length < 1) {
                    input.addClass('invalid');
                } else {
                    input.removeClass('invalid');
                }
            };

            checkBirthdate();
            form.find('#birthdate').on("change keyup paste click", function(){
                checkBirthdate();
            });

            var checkProof = function () {
                var postStatus = $('article#actor').attr('data-status');
                var nationality = form.find('#nationality');

                var inputId = form.find('#id-card').parent().parent().find('.file-path-wrapper > .file-path');
                var inputProof = form.find('#proof-of-address').parent().parent().find('.file-path-wrapper > .file-path');
                var inputResidencePermitFile = form.find('#residence-permit-file').parent().parent().find('.file-path-wrapper > .file-path');

                // TODO

                if (nationality.val() === 'ch') {
                    // NB: disable this check because the user can't submit the form if he just want to edit other info like its birthdate for example...
                    /*if (!$('.wrapper-id-card').hasClass('hidden')) {
                        if (form.find('.content-document').find('.chip.id-card').length < 1 && form.find('#id-card').val().length < 1) {
                            inputId.removeClass('valid');
                            inputId.addClass('invalid');
                        } else {
                            inputId.removeClass('invalid');
                        }
                        inputProof.removeClass('invalid');
                    }*/
                } else {
                    if (!$('.wrapper-proof-of-address').hasClass('hidden')) {
                        if (form.find('.content-document').find('.chip.proof-address').length < 1 && form.find('#proof-of-address').val().length < 1) {
                            inputProof.removeClass('valid');
                            inputProof.addClass('invalid');
                        } else {
                            inputProof.removeClass('invalid');
                        }
                        inputId.removeClass('invalid');
                    }
                }
            };

            checkProof();

            form.find('#nationality').change(function () {
                checkNationality();
                checkProof();
            });
        }
    },

    submitForm: function () {
        var self = this;
        var profileForm = $('#edition-personal-data');

        profileForm.submit(function(event) {
            event.preventDefault();

            self.validatePersonalDataForm(profileForm);

            if (profileForm.find('.invalid').length > 0) {
                M.toast({html:'<span>Certains champs sont requis</span>'}, 5000);
                return;
            }

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', profileForm).hide();
            $('.preloader-wrapper', profileForm).fadeIn();

            var ajaxAction = 'actors.edit_profile';

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(profileForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                data: formdata ? formdata : profileForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    // Update view
                    var parent = $('.content-personal-data').parent();
                    $('.content-personal-data').remove();
                    parent.append(response.data.html);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    // Check if the actor profile is completed (all mandatory fields filled)
                    self.checkProfileCompleted();
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, profileForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', profileForm).fadeOut();
                $('#submit', profileForm).show();
            }).fail(function (jqXHR, textStatus) {

                self.lockAjaxForm = false;

                $('.preloader-wrapper', profileForm).fadeOut();
                $('#submit', profileForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },
    contactActor: function() {
        $('main#content .btn-send-message').on('click', function(e) {
            console.log("btn-send-message");
            var self = this;
            var $modal = $('#modal-contact');
            $modal.modal('open');
        });
    },
    submitContactForm: function () {
        var self = this;
        var $modal = $('#modal-contact');

        $('#message', $modal).characterCounter();

        $('form', $modal).on('submit', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            var ajaxAction = 'actors.contact';
            var contactForm = $('form', $modal);

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(contactForm[0]);
                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            // Bug fix Safari 11 / Webkit
            // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
            // @link https://trac.webkit.org/changeset/230963/webkit
            $("input[type=file]", contactForm).each(function () {
                if ($(this).val() === "") {
                    formdata.delete($(this).attr("name"));
                }
            });

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : contactForm.sesrialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                $('.preloader-wrapper', $modal).fadeOut();
                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                if (response.success) {
                    $modal.modal('close');
                    M.toast({html: '<span>'+comedien.i18n.actorContactMsgSend+'</span>'}, 5000);
                    $('#subject', $modal).val('');
                    $('#message', $modal).val('');
                    $('#contactFiles', $modal).val('');
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, $modal).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);

                $modal.modal('close');
            });
        });
    },

    openFeatured: function () {
        $('#edit-feat').on('click', function () {
            // Open side nav
            $('.button-collapse[data-target="add-featured"]').trigger('click');
        });
    },

    submitFeaturedForm: function () {
        var self = this;

        var form = $('#edition-featured');

        form.submit(function (event) {
            event.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            $('#submit', form).hide();
            $('.preloader-wrapper', form).fadeIn();

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);

                formdata.append('action', 'actors.edit_featured');
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=actors.edit_featured&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function (response) {
                if (response.success) {
                    // Update view
                    var parent = $('.parent-image');
                    parent.find('.main-image').remove();

                    parent.append(response.data.html);

                    // Close the side nav
                    $("#wrapper .sidenav").sidenav('close');

                    self.cleanForm(form);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, form).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', form).fadeOut();
                $('#submit', form).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    computeUiTitlesSeparator: function() {
        var compute = function(element) {
            var containerWidth = $(element).width();
            var labelWidth = $('h3', element).outerWidth(true);
            var btnWidth = $('span', element).outerWidth(true);
            var separatorWidth = containerWidth - (labelWidth + btnWidth);



            if (separatorWidth > 0) {

                $('hr', element).css({
                    'width': separatorWidth + 'px',
                    'opacity': 1,
                    'right': btnWidth,
                });
            }
        };

        $('main#content .cm-collapsible .collapsible-header .one-border').each(function() {

            compute(this);
        });
    },

    addActorToCasting: function() {
        var self = this;
        var $modal = $('#modal-add-actor-casting');
        var $dropdownCasting = $('#dropdownCasting', $modal);
        var $dropdownRoles = $('#dropdownRoles', $modal);
        var data = null;

        var populateDropdownCasting = function() {
            // Remove all options
            $dropdownCasting.find('option:not(.optSelect)').remove();

            // Display a list of casting
            $.each(data, function (i, item) {
                $dropdownCasting.append($('<option>', {
                    value: item.idPost,
                    text : item.title
                }));
            });

            $dropdownCasting.formSelect('destroy');
            $dropdownCasting.formSelect();
        };

        var populateDropdownRoles = function() {
            // Remove all options
            $dropdownRoles.find('option:not(.optSelect)').remove();

            $dropdownRoles.formSelect('destroy');
            $dropdownRoles.formSelect();

            var idCasting = parseInt($dropdownCasting.val()) || 0;

            if (idCasting == 0) {
                $('.content-before .btn-confirm', $modal).addClass('disabled');
            }
        };

        // Display a list of roles when the user select a casting
        $dropdownCasting.on('change', function() {
            var idCasting = parseInt($(this).val()) || 0;

            if (idCasting > 0) {
                populateDropdownRoles();

                $.each(data, function (i, item) {
                    var idPost = parseInt(item.idPost) || 0;
                    if (idPost == idCasting) {
                        var nbRolesAdded = 0;

                        $.each(item.roles, function (i, role) {
                            if (role.id != '00000000000000000000000000000000') {
                                $dropdownRoles.append($('<option>', {
                                    value: role.id,
                                    text: role.name
                                }));

                                nbRolesAdded++;
                            }
                        });

                        $dropdownRoles.formSelect('destroy');
                        $dropdownRoles.formSelect();

                        if (nbRolesAdded == 0) {
                            M.toast({html:'<span>'+ comedien.i18n.actorNoRolesForThisCasting +'</span>'}, 5000);
                        }

                        return false;
                    }
                });
            }
        });

        // Display the submit button when a user select a role for a given casting
        $dropdownRoles.on('change', function() {
            var selectedOpt = [];
            $('#dropdownRoles :selected').each(function(i, selected){
                selectedOpt[i] = $(selected).text();
            });

            if (selectedOpt.length > 0) {
                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                // When the user select an option, automatically close the dropdown menu
                // The Materialize framework doest not provide this option. In order to do that,
                // we must destroy the dropdown and recreate it just after.
                $dropdownRoles.formSelect('destroy');
                $dropdownRoles.formSelect();
            } else {
                $('.content-before .btn-confirm', $modal).addClass('disabled');
            }
        });

        // Get a list of casting for the current logged in user
        $('main#content .btn-add-actor-casting').on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxCasting) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxCasting = true;

            data = null;

            $modal.modal('open');

            $dropdownRoles.val([]);
            $dropdownRoles.formSelect('destroy');
            $dropdownRoles.formSelect();

            $dropdownCasting.val();
            $dropdownCasting.formSelect('destroy');
            $dropdownCasting.formSelect();

            $('.input-field', $modal).hide();
            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');

            var ajaxAction = 'actor.casting.get_list';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security,
            }).done(function(response) {
                if (response.success) {
                    $('.preloader-wrapper', $modal).fadeOut();
                    $('.input-field', $modal).show();

                    data = response.data;

                    // Autopopulate the dropdowns
                    populateDropdownCasting();
                    populateDropdownRoles();
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    $modal.modal('close');
                }

                //$('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                self.lockAjaxCasting = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxCasting = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                $modal.modal('close');
            });
        });

        // Add the current viewed actor to the selected casting (for the selected role)
        $('.content-before .btn-confirm', $modal).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxCasting) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxCasting = true;

            var idCasting = $dropdownCasting.val();
            var idRoles = $dropdownRoles.val();
            var idActor = $('article#actor').data('id');

            var ajaxAction = 'actor.casting.add_to_role';

            $('.error', $modal).hide();
            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idCasting=" + idCasting + "&idRoles=" + idRoles + "&idActor=" + idActor,
            }).done(function(response) {
                $('.preloader-wrapper', $modal).fadeOut();
                $('.content-before .btn-confirm', $modal).removeClass('disabled');
                $('.content-before .modal-action', $modal).removeClass('disabled');

                if (response.success) {
                    $dropdownCasting.val('');
                    $dropdownRoles.val('');

                    M.toast({html:'<span>'+ comedien.i18n.actorAddedToUserCasting +'</span>'}, 5000);

                    $modal.modal('close');

                    // Redirect to the casting after 1s
                    setTimeout(function () {
                        window.location.replace(comedien.user.urlDashboard + 'casting/edit/' + idCasting + '/');
                    }, 1000);
                } else {
                    $('.error', $modal).fadeIn();

                    $dropdownCasting.val('');
                    $dropdownCasting.formSelect('destroy');
                    $dropdownCasting.formSelect();

                    $dropdownRoles.val('');
                    $dropdownRoles.formSelect('destroy');
                    $dropdownRoles.formSelect();

                    $('.content-before .btn-confirm', $modal).addClass('disabled');

                    M.toast({html:'<span>'+ comedien.i18n.actorNotAddedToUserCasting +'</span>'}, 5000);
                }

                self.lockAjaxCasting = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxCasting = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);

                $modal.modal('close');
            });
        });
    },

    askProfileValidation: function() {
        var self = this;
        var $btn = $('#askProfileValidation');

        $btn.on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxAskProfileValidation) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxAskProfileValidation = true;

            $btn.addClass('disabled');
            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

            var ajaxAction = 'actors.ask_profile_validation'
            var idActor = $('article#actor').data('id');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&idActor=" + idActor,
            }).done(function(response) {
                $('.toastLoading').remove();

                if (response.success) {
                    $('main#content .notice').hide();
                    $('main#content #noticeProfileValidationRequestSend').show();
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $btn.removeClass('disabled');

                self.lockAjaxAskProfileValidation = false;
            }).fail(function(jqXHR, textStatus) {
                $('.toastLoading').remove();
                $btn.removeClass('disabled');
                self.lockAjaxAskProfileValidation = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    /**
     * Checks if the actor profile is completed (all mandatory fields filled).
     * This method should be called when then user update its data.
     */
    checkProfileCompleted: function() {
        var self = this;

        if (self.lockAjaxCheckProfileCompleted) {
            return;
        }

        self.lockAjaxCheckProfileCompleted = true;

        var ajaxAction = 'actors.check_profile_completed'
        var idActor = $('article#actor').data('id');

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: "action=" + ajaxAction + "&security=" + comedien.security + "&idActor=" + idActor,
        }).done(function(response) {
            if (response.success) {
                if (response.data.isWaitingForProfileValidation) {
                    $('main#content .notice').hide();
                    $('main#content #noticeProfileValidationRequestSend').show();
                } else if (response.data.isCompleteProfile) {
                    $('main#content .notice').hide();
                    $('main#content #noticeProfileValidationReadyToRequest').show();
                }
            }

            self.lockAjaxCheckProfileCompleted = false;
        }).fail(function(jqXHR, textStatus) {
            self.lockAjaxCheckProfileCompleted = false;
            console.log("Request failed: " + textStatus);
        });
    },

    setColumnsMinHeight: function() {
        setTimeout(function() {
            var contentHeight = $('article#actor .col-content').height();
            var sidebarHeight = $('article#actor .col-left').height();
            var sidebarInnerHeight = $('article#actor .col-left > .inner').height();

            if (sidebarInnerHeight > sidebarHeight && sidebarInnerHeight > contentHeight) {
                $('article#actor .col-content').css('min-height', Math.floor(sidebarInnerHeight) + 'px');
            }
        }, 1000);
    },

    preparePrint: function() {
        $('#btn-print').on('click', function(e) {
            e.preventDefault();

            $('article#actor .cm-collapsible').collapsible('open', 1);
            $('article#actor .cm-collapsible').collapsible('open', 2);
            $('article#actor .cm-collapsible').collapsible('open', 3);
            $('article#actor .cm-collapsible').collapsible('open', 4);
            $('article#actor .cm-collapsible').collapsible('open', 5);

            setTimeout(function() {
                window.print();
            }, 1000);
        });
    },

    mobileScrollToGallery : function () {
        var $header = $('#header-actions');

        $('.btn-scroll-media', $header).on('click', function() {
            $('html, body').animate({
                scrollTop: $('.mobile.gallery').offset().top - $('#site-header .wrapper').height()
            }, 500);
        })
    },
};

module.exports = new FrontActorsSingle();
